import { render, staticRenderFns } from "./CrmOpportunityOrigin.vue?vue&type=template&id=1dbac2c2&scoped=true&"
import script from "./CrmOpportunityOrigin.vue?vue&type=script&lang=js&"
export * from "./CrmOpportunityOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbac2c2",
  null
  
)

export default component.exports